//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Ø¬ÙÙØ±Û',
            'ÙØ±ÙØ±Û',
            'ÙØ§Ø±Ú',
            'Ø§Ù¾Ø±ÛÙ',
            'ÙØ¦Û',
            'Ø¬ÙÙ',
            'Ø¬ÙÙØ§Ø¦Û',
            'Ø§Ú¯Ø³Øª',
            'Ø³ØªÙØ¨Ø±',
            'Ø§Ú©ØªÙØ¨Ø±',
            'ÙÙÙØ¨Ø±',
            'Ø¯Ø³ÙØ¨Ø±',
        ],
        days = ['Ø§ØªÙØ§Ø±', 'Ù¾ÛØ±', 'ÙÙÚ¯Ù', 'Ø¨Ø¯Ú¾', 'Ø¬ÙØ¹Ø±Ø§Øª', 'Ø¬ÙØ¹Û', 'ÛÙØªÛ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ddddØ D MMMM YYYY HH:mm',
        },
        meridiemParse: /ØµØ¨Ø­|Ø´Ø§Ù/,
        isPM: function (input) {
            return 'Ø´Ø§Ù' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ØµØ¨Ø­';
            }
            return 'Ø´Ø§Ù';
        },
        calendar: {
            sameDay: '[Ø¢Ø¬ Ø¨ÙÙØª] LT',
            nextDay: '[Ú©Ù Ø¨ÙÙØª] LT',
            nextWeek: 'dddd [Ø¨ÙÙØª] LT',
            lastDay: '[Ú¯Ø°Ø´ØªÛ Ø±ÙØ² Ø¨ÙÙØª] LT',
            lastWeek: '[Ú¯Ø°Ø´ØªÛ] dddd [Ø¨ÙÙØª] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s Ø¨Ø¹Ø¯',
            past: '%s ÙØ¨Ù',
            s: 'ÚÙØ¯ Ø³ÛÚ©ÙÚ',
            ss: '%d Ø³ÛÚ©ÙÚ',
            m: 'Ø§ÛÚ© ÙÙÙ¹',
            mm: '%d ÙÙÙ¹',
            h: 'Ø§ÛÚ© Ú¯Ú¾ÙÙ¹Û',
            hh: '%d Ú¯Ú¾ÙÙ¹Û',
            d: 'Ø§ÛÚ© Ø¯Ù',
            dd: '%d Ø¯Ù',
            M: 'Ø§ÛÚ© ÙØ§Û',
            MM: '%d ÙØ§Û',
            y: 'Ø§ÛÚ© Ø³Ø§Ù',
            yy: '%d Ø³Ø§Ù',
        },
        preparse: function (string) {
            return string.replace(/Ø/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, 'Ø');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));
